__turbopack_context__.v({
  "divider": "SectionDivider-module-scss-module__am47_W__divider",
});
